// extracted by mini-css-extract-plugin
export default {"sequence":"BSequenceItem-module_sequence_b2ea4e1f"};